"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAccessRoute = checkAccessRoute;
exports.checkUserPermission = checkUserPermission;
exports.default = checkPermission;
exports.generateRoutesPath = generateRoutesPath;
require("core-js/modules/es6.regexp.replace");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _store = _interopRequireDefault(require("@/store"));
var _router = require("@/router");
/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
function checkPermission(value) {
  if (value && value instanceof Array && value.length > 0) {
    var roles = _store.default.getters && _store.default.getters.roles;
    var permissionRoles = value;
    var hasPermission = roles.some(function (role) {
      return permissionRoles.includes(role);
    });
    if (!hasPermission) {
      return false;
    }
    return true;
  } else {
    // eslint-disable-next-line no-console
    console.error("need roles! Like v-permission=\"['admin','editor']\"");
    return false;
  }
}
function generateRoutesPath() {
  var res = JSON.stringify(_router.constantRoutes);
  res = JSON.parse(res);
  var routes = res.filter(function (route) {
    return route.permission;
  });
  var _iterator = (0, _createForOfIteratorHelper2.default)(routes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var route = _step.value;
      delete route.component;
      var _iterator2 = (0, _createForOfIteratorHelper2.default)(route.children),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          delete child.component;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return routes;
}
function checkAccessRoute(route) {
  // const routes = store.getters.permission_routes
  var resRoute = JSON.stringify(_router.constantRoutes);
  resRoute = JSON.parse(resRoute);
  // lay ds route co permission giong voi role hien tai
  var routes = resRoute.filter(function (route) {
    return !route.hidden && route.permission && route.meta.permissionName.includes(_store.default.getters.info.role.name);
  });
  // bien doi routes thanh ds routes co duong dan full
  routes = routes.flatMap(function (route) {
    return (route.children || []).map(function (child) {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, child), {}, {
        fullPath: "".concat(route.path, "/").concat(child.path).replace(/\/+/g, "/")
      });
    });
  });

  // tim duong dan co ton tai trong mang
  var res = routes.some(function (item) {
    return item.fullPath == route;
  });
  if (res) {
    return res;
  } else {
    if (routes.length) {
      return routes[0].fullPath;
    } else {
      return "/404";
    }
  }
}
function checkUserPermission(value) {
  if (value && value instanceof Array && value.length > 0) {
    var info = _store.default.getters && _store.default.getters.info;
    var permissionRoles = value;
    var hasPermission = permissionRoles.includes(info.role.name);
    if (!hasPermission) {
      return false;
    }
    return true;
  } else {
    // eslint-disable-next-line no-console
    console.error("need roles! Like v-permission=\"['admin','editor']\"");
    return false;
  }
}